import { z } from 'zod';

const LOCAL_STORAGE_KEY = 'userDashboardConfig';

const userDisplayConfigSchema = z.object({
  collapsedHeader: z.boolean().optional(),
  groupsTaskList: z.unknown().optional()
});

export type UserDisplayConfig = z.infer<typeof userDisplayConfigSchema>;

export const getUserDisplayConfig = (): UserDisplayConfig => {
  try {
    const raw = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = userDisplayConfigSchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : {};
  } catch {
    return {};
  }
};

export const saveUserDisplayConfig = (config: UserDisplayConfig): void => {
  try {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(config));
  } catch {
    // best-effort persistence; ignore quota/serialization errors
  }
};
